import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import {
  AddEvaluatorInfo,
  GetEvaluatorInfoRowByUserId,
} from "../../../Redux/Reducers/Manager/EvaluatorInfo";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import { GetRondAndFieldList } from "../../../Redux/Reducers/Manager/Dropdowns/FieldRond";

import Select from "react-select";
import "./style.css";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { GetAllRoundActive } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import { GetAllFieldsByRoundManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldByRound";
import EvaluatorTable from "./EvaluatorTable";
import Swal from "sweetalert2";
const SetEvaluterForm = (props) => {
  const dispatch = useDispatch();
  const { userId } = useParams();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const [DropDownRoundActive, setDropDownRoundActive] = useState("");
  const [DropDownFields, setDropDownFields] = useState("");
  const EvaluatorInfoRow = useSelector(
    (state) => state.EvaluatorInfo?.EvaluatorInfoRow
  );

  const state = useSelector((state) => {
    return {
      DropDownRoundActive: state.DropDownRoundActive.DropDownRoundActive,
      DropDownFieldsManager: state.DropDownFieldsManager.DropDownFieldsManager,
      DropDownFlow: state.DropDownFlow.DropDownFlow,
      DropDownActionByFlowId:
        state.DropDownActionByFlowId.DropDownActionByFlowId,
      AddEvaluatorInfoRow: state.EvaluatorInfo.AddEvaluatorInfoRow,
    };
  });

  console.log(state.AddEvaluatorInfoRow, "Add");

  const fieldRond = useSelector(
    (state) => state.FieldRondReducer?.RoundFieldList
  );
  console.log(fieldRond, "EvaluatodddddwdrInfoRow");

  useEffect(() => {
    dispatch(GetEvaluatorInfoRowByUserId({ uS_UserGuid: userId }));
  }, [userId]);
  useEffect(() => {
    dispatch(GetRondAndFieldList());
  }, []);
  console.log(EvaluatorInfoRow, "selectedOddddddddptions");

  const handleAddEvaluatorInfo = async () => {
    const missingFields = [];

    if (!DropDownRoundActive) missingFields.push("الدورة");
    if (!DropDownFields) missingFields.push("الحقل");
    if (!EvaluatorInfoRow?.userGuid) missingFields.push("المقيّم");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align: right; direction: rtl; font-size: 16px;">
          <ul style="list-style-type: none; padding: 0;">
            ${missingFields
              .map(
                (field) =>
                  `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
              )
              .join("")}
          </ul>
        </div>
      `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }

    try {
      const result = await dispatch(
        AddEvaluatorInfo({
          userId: EvaluatorInfoRow?.userGuid,
          fieldId: DropDownFields,
          roundId: DropDownRoundActive,
        })
      ).unwrap();

      if (result.message === "لا يمكن تكرار نفس الحقل لنفس الدورة") {
        Swal.fire({
          icon: "error",
          title: "تنبيه",
          text: result.message,
          confirmButtonText: "حسناً",
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "تمت الإضافة بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: error?.message || "حدث خطأ غير متوقع",
        confirmButtonText: "حسناً",
      });
    }
  };

  useEffect(() => {
    dispatch(GetAllRoundActive());
  }, []);

  useEffect(() => {
    if (DropDownRoundActive) {
      dispatch(
        GetAllFieldsByRoundManager({
          sU_ST_MRI_RoundYearId: parseInt(DropDownRoundActive),
        })
      );
    }
  }, [DropDownRoundActive]);
  return (
    <>
      {EvaluatorInfoRow ? (
        <SharedDiv
          showTitle={true}
          titleName="معلومات الطلب"
          child={[
            <div className="containerSetEvaluterForm">
              <div className="containerSetEvaluterFormChild">
                <div className="form-grid">
                  <InputAHSF
                    fieldsName="EvaluatorName"
                    show={true}
                    disabled={true}
                    defaultValue={EvaluatorInfoRow?.evaluatorName}
                    onChange={(e) => {
                      //   setObjectives(e.target.value);
                    }}
                    showValidationMessage={false}
                    validationMessage={"حقل اجباري"}
                  />

                  <InputAHSF
                    fieldsName="EmailEvaluator"
                    show={true}
                    disabled={true}
                    defaultValue={EvaluatorInfoRow?.email}
                    onChange={(e) => {
                      //   setObjectives(e.target.value);
                    }}
                    showValidationMessage={false}
                    validationMessage={"حقل اجباري"}
                  />

                  <AllDropDownsAHSF
                    fieldsName="Round"
                    show={true}
                    arrayOoptionList={state.DropDownRoundActive}
                    KeyText={"roundName"}
                    KeyValue={"sU_ST_MRI_RoundYearId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownRoundActive(e.target.value);
                      // props.setRoundActive(e.target.value);
                      // console.log(DropDownRoundActive, "round");
                    }}
                  />
                  <AllDropDownsAHSF
                    fieldsName="FieldManager"
                    show={true}
                    arrayOoptionList={state.DropDownFieldsManager}
                    KeyText={"fieldName"}
                    KeyValue={"fieldId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownFields(e.target.value);
                      // props.setFields(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>,
            <div className="ConainerButtonAHSF">
              <ButtonAHSF
                onClick={handleAddEvaluatorInfo}
                text={"اضافة"}
                show={true}
              />
            </div>,
            <EvaluatorTable />,
          ]}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default SetEvaluterForm;
